export const isPopulatedString = (value: string | undefined) =>
  typeof value === "string" && value.trim();
